module.exports = __webpack_public_path__ + "img/gzrw3.4a3fea18.png";